"use strict";

import angular from "angular";

import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { User } from "../../../gateway/User/User";
import template from "./data-comments-reviews.component.html";
import "./data-comments-reviews.component.scss";

/**
 * @component NuDataCommentsReviews
 * O <nu-data-comments-reviews> é um componente usado para mostrar um textarea para receber reviews e comentários
 */

class NuDataCommentsReviews {
    constructor($timeout) {
        this.isEditable = false;
        this.$timeout = $timeout;
        this.commentInitial = this.commentInitial;
        this.User = new User();
    }
    $onInit = () => {
        this.user = new UserDataAdapter().user();
    };
    textareaFocus = () => {
        const textarea = angular.element(
            document.querySelector(".data__input-comments ")
        );
        setTimeout(() => {
            textarea[0].focus();
        }, 100);
    };
    enterKeyDisable = (e) => {
        let key = e.keyCode || e.charCode;
        if (key === 13) e.preventDefault();
    };
    isCompanyUser = () => {
        return this.User.checkPermission({
            roles: this.user.roles,
            granted: ["Empresa"]
        });
    };
}

NuDataCommentsReviews.$inject = ["$timeout"];

const name = "nuDataCommentsReviews";
const def = {
    factory: [
        function () {
            return {
                controller: NuDataCommentsReviews,
                restrict: "E",
                controllerAs: "nuDataCommentsReviews",
                scope: {
                    onSubmit: "=",
                    comment: "=",
                    isEditable: "@"
                },
                bindToController: true,
                template
            };

        }
    ]
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
